import React from 'react';

import PartnerTextDisclaimer from 'partial/OfferManager/modules/PartnerTextDisclaimer';
import AutoRefinanceModuleRedesign from 'partial/OfferManager/modules/AutoRefinanceModuleRedesign';
import HomeLoanModuleRedesign from 'partial/OfferManager/modules/HomeLoanModuleRedesign';
import InsuranceModuleRedesign from 'partial/OfferManager/modules/InsuranceModuleRedesign';
import ExploreOffersModule from 'partial/OfferManager/modules/ExploreOffersModule';
import AutoLoanModuleRedesign from 'partial/OfferManager/modules/AutoLoanModuleRedesign';
import SuggestedCreditCardModuleRedesign from 'partial/OfferManager/modules/SuggestedCreditCardModuleRedesign';
import PersonalLoanModuleRedesign from 'partial/OfferManager/modules/PersonalLoanModuleRedesign';
import NativeAdModule from 'partial/OfferManager/modules/NativeAdModule';
import ActionsModuleRedesign from 'partial/OfferManager/modules/ActionsModuleRedesign';
import CreditCardPlusModule from 'partial/OfferManager/modules/CreditCardPlusModule';
import Default from 'partial/OfferManager/modules/Default';
import FeaturedAdModule from 'partial/OfferManager/modules/FeaturedAd';
import EngagementOffersModule from 'partial/OfferManager/modules/EngagementOffersModule';
import CreditToolsModule from 'partial/OfferManager/modules/CreditToolsModule';
import SectionHeaderModule from 'partial/OfferManager/modules/SectionHeaderModule';
import UnifiedCashEnrollPlusBanner from 'partial/OfferManager/modules/UnifiedCashEnrollPlusBanner';
import CreditBuilderModule from 'components/CreditBuilderModule';
import PlusOverviewBannerModule from 'partial/OfferManager/modules/PlusOverviewBannerModule';
import AvailableForYouModule from 'partial/OfferManager/modules/AvailableForYouModule';

const TodayDashboardModule = props => {
  switch (props?.module) {
    case 'ACTIONS':
      return <ActionsModuleRedesign {...props} />;
    case 'PERSONAL_LOAN_REDESIGN':
      return <PersonalLoanModuleRedesign {...props} />;
    case 'AUTO_REFINANCE_REDESIGN':
      return <AutoRefinanceModuleRedesign {...props} />;
    case 'AUTO_LOAN_REDESIGN':
      return <AutoLoanModuleRedesign {...props} />;
    case 'INSURANCE_REDESIGN':
      return <InsuranceModuleRedesign {...props} />;
    case 'HOME_LOAN_REDESIGN':
      return <HomeLoanModuleRedesign {...props} />;
    case 'SUGGESTED_CREDIT_CARD_REDESIGN':
    case 'SUGGESTED_CREDIT_CARD_BASIC':
      return <SuggestedCreditCardModuleRedesign {...props} />;
    case 'PARTNER_TEXT_DISCLAIMER':
      return <PartnerTextDisclaimer {...props} />;
    case 'EXPLORE_OFFERS_REDESIGN':
      return <ExploreOffersModule {...props} />;
    case 'NATIVE_ADS':
      return <NativeAdModule {...props} />;
    case 'FEATURED_AD':
      return <FeaturedAdModule {...props} />;
    case 'CREDIT_BUILDER_MODULE':
      return <CreditBuilderModule {...props} />;
    case 'SUBSCRIPTION_OVERVIEW_BANNER_MODULE':
      return <PlusOverviewBannerModule {...props} />;
    case 'UNIFIED_ENROLL_PLUS_BANNER':
      return <UnifiedCashEnrollPlusBanner {...props} />;
    case 'PLUS_PICK_CREDIT_CARD':
      return <CreditCardPlusModule {...props} />;
    case 'PROFILE_PAGE_EVENT_OFFER':
      return <EngagementOffersModule {...props} />;
    case 'PRESCREEN_OFFERS':
      return <EngagementOffersModule {...props} />;
    case 'MODULE_SECTION_AVAILABLE_CREDIT_OFFERS':
    case 'MODULE_SECTION_SESAME_PLUS_PAYMENT_HISTORY_TOOLS':
    case 'MODULE_SECTION_AVAILABLE_CREDIT_CARD_OFFERS':
    case 'MODULE_SECTION_TOP_ACTIONS_FOR_YOUR_GRADE':
    case 'MODULE_SECTION_MORE_OFFERS':
    case 'MODULE_SECTION_SESAME_PLUS_CREDIT_TOOLS':
    case 'MODULE_SECTION_MORE_FOR_YOU':
      return <SectionHeaderModule {...props} />;
    case 'CREDIT_TOOLS':
      return (
        <CreditToolsModule
          className={
            props?.extraAttributes?.showModuleAvailableForYou ? '' : 'd-hide'
          }
          isDesktopCarouselView={
            props?.extraAttributes?.showModuleAvailableForYou
          }
          {...props}
        />
      );
    case 'AVAILABLE_FOR_YOU':
      return <AvailableForYouModule className={'d-hide'} {...props} />;
    default:
      return <Default {...props} />;
  }
};

export default TodayDashboardModule;
